export const DATE = 'DATE';
export const INDEXED = 'INDEXED';
export const PROPERTY_REFERENCED = 'PROPERTY_REFERENCED';